import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import Header from 'Components/Header';
import React from 'react';
import { useSelector } from 'react-redux';
import icons from 'utils/ui/icons';
import AppRoutes from './Routes';

const Container = styled(Grid)({
    position: 'relative',
    top: 64,
    bottom: 0,
    left: 0,
    right: 0,
    height: 'calc(100vh - 64px)'
});

const generateSections = user => {
    const catalogSections = [
        { text: 'Equipment', icon: icons.equipment, url: '/equipment' }
    ];

    if (user?.root) {
        catalogSections.push({
            text: 'Equipment Categories',
            icon: icons.equipmentCategories,
            url: '/equipment_categories'
        });
    }

    const sections = [
        {
            name: 'Sites',
            subsections: [
                { text: 'Map', icon: icons.map, url: '/map' },
                { text: 'Table', icon: icons.table, url: '/sites' }
            ]
        },
        { name: 'Catalog', subsections: catalogSections }
    ];

    if (user?.superuser) {
        sections.push({
            name: 'WiseBoxes',
            subsections: [
                { text: 'Table', icon: icons.table, url: '/wise_boxes' },
                { text: 'Templates', icon: icons.templateDownload, url: '/templates' },
                { text: 'Unclaimed', icon: icons.unclaimed, url: '/unclaimed' }
            ]
        });
    }

    if (user?.root) {
        sections.push({
            name: 'Accesses',
            subsections: [{ text: 'Users', icon: icons.users, url: '/users' }]
        });
    }

    return sections;
};

const Layout = () => {
    const user = useSelector(state => state.users.models[state.auth.currentUserId]);

    return (
        <>
            <Header sections={generateSections(user)}/>
            <Container container spacing={0}>
                <AppRoutes/>
            </Container>
        </>
    );
};

export default Layout;
